import React from "react";
import { Route, Routes } from "react-router-dom";
import Individual from "@/pages/particular-signup/index";
import Amenities from "@/pages/particular-signup/amenities/index";
import Description from "@/pages/particular-signup/description/index";
import SelectPlan from "@/pages/particular-signup/select_plan/index";
import PaymentReturn from "@/pages/particular-signup/success_payment/index";
import PropertyAndLocation from "@/pages/particular-signup/location_price/index";
import ProSignup from "./pro";
import VerifyEmail from "./verify-email";

export default function Signup() {
  return (
    <div>
      <Routes>
        <Route path="/particular" element={<Individual />} />
        <Route path="/amenidades" element={<Amenities />} />
        <Route path="/descripcion" element={<Description />} />
        <Route path="/seleccionar-plan" element={<SelectPlan />} />
        <Route path="/pago-exitoso" element={<PaymentReturn />} />
        <Route path="/ubicacion-precio" element={<PropertyAndLocation />} />
        <Route path="/pro" element={<ProSignup />} />
        <Route path="/verificar-correo" element={<VerifyEmail />} />
      </Routes>
    </div>
  );
}
